import { render } from "./AuthComponent.vue?vue&type=template&id=3873159c&scoped=true"
import script from "./AuthComponent.vue?vue&type=script&lang=js"
export * from "./AuthComponent.vue?vue&type=script&lang=js"

import "./AuthComponent.vue?vue&type=style&index=0&id=3873159c&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3873159c"]])

export default __exports__